import { useState, type ChangeEvent } from 'react';
import {
  Card, Input, Button, List, Tag, Typography, Space, Badge, Divider, message,
} from 'antd';
import {
  SendOutlined, LinkOutlined, DisconnectOutlined,
} from '@ant-design/icons';
import { useWebSocket } from '../../hooks/useWebSocket';

const { Text, Title } = Typography;

export default function IotPanel() {
  const [topics, setTopics] = useState('');
  const [publishTopic, setPublishTopic] = useState('');
  const [publishMsg, setPublishMsg] = useState('');
  const { connected, messages, subscribe, unsubscribe, publish } = useWebSocket();

  const handleSubscribe = () => {
    const topicList = topics.split(',').map((t) => t.trim()).filter(Boolean);
    if (topicList.length === 0) {
      message.warning('请输入 Topic');
      return;
    }
    subscribe(topicList);
    message.success(`已订阅: ${topicList.join(', ')}`);
  };

  const handlePublish = () => {
    if (!publishTopic || !publishMsg) {
      message.warning('请输入 Topic 和消息内容');
      return;
    }
    publish(publishTopic, publishMsg);
    message.success('已发布');
  };

  return (
    <div style={{ padding: 12 }}>
      <Space style={{ marginBottom: 12, width: '100%', justifyContent: 'space-between' }}>
        <Title level={5} style={{ margin: 0 }}>IoT 数据面板</Title>
        <Badge
          status={connected ? 'success' : 'error'}
          text={connected ? '已连接' : '未连接'}
        />
      </Space>

      <Card size="small" title="订阅 Topic" style={{ marginBottom: 12 }}>
        <Space orientation="vertical" style={{ width: '100%' }} size="small">
          <Input
            size="small"
            placeholder="输入 Topic，逗号分隔（如 sensor/temp, sensor/humidity）"
            value={topics}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setTopics(e.target.value)}
          />
          <Button
            type="primary"
            size="small"
            icon={<LinkOutlined />}
            onClick={handleSubscribe}
            disabled={!connected}
            block
          >
            订阅
          </Button>
        </Space>
      </Card>

      <Card size="small" title="发布消息" style={{ marginBottom: 12 }}>
        <Space orientation="vertical" style={{ width: '100%' }} size="small">
          <Input
            size="small"
            placeholder="Topic"
            value={publishTopic}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setPublishTopic(e.target.value)}
          />
          <Input
            size="small"
            placeholder="消息内容"
            value={publishMsg}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setPublishMsg(e.target.value)}
          />
          <Button
            size="small"
            icon={<SendOutlined />}
            onClick={handlePublish}
            disabled={!connected}
            block
          >
            发布
          </Button>
        </Space>
      </Card>

      <Divider style={{ margin: '8px 0' }} />

      <Text strong style={{ fontSize: 12 }}>
        实时消息 ({messages.length})
      </Text>
      <List
        size="small"
        style={{ marginTop: 8, maxHeight: 300, overflow: 'auto' }}
        dataSource={messages}
        locale={{ emptyText: '暂无数据' }}
        renderItem={(msg) => (
          <List.Item style={{ padding: '4px 0' }}>
            <div style={{ width: '100%' }}>
              <Space>
                <Tag color="blue" style={{ fontSize: 11 }}>
                  {msg.topic}
                </Tag>
                <Text style={{ fontSize: 11, color: '#888' }}>
                  {new Date(msg.timestamp).toLocaleTimeString()}
                </Text>
              </Space>
              <div style={{ fontSize: 12, color: '#fff', marginTop: 2 }}>
                {msg.message}
              </div>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
}
